import { isOpenFeedDrop } from "../services/dropsFeedService";

/**
 * Home sidebar "Closing soon" cutoff.
 * Followed creators only, latest drop per creator, still open, this many views left.
 * Home keeps this cutoff alone. The games panel may fill past it.
 */
export const FOLLOWED_CLOSING_SOON_MAX_LEFT = 15;

/** Games panel only: fill when the <=15 set is thinner than this. */
export const PANEL_CLOSING_MIN_CARDS = 3;

/** Games panel only: primary cards plus fallback, matching the reference's four cards. */
export const PANEL_CLOSING_MAX_CARDS = 4;

export function viewsLeft(drop) {
  return Math.max((drop.maxViews || 100) - (drop.viewCount || 0), 0);
}

export function pctTowardCap(drop) {
  const max = drop.maxViews || 100;
  return Math.min(100, Math.round(((drop.viewCount || 0) / max) * 100));
}

/** Same predicate Home's sidebar used inline: row.drop && open && viewsLeft <= 15. */
export function isFollowedClosingSoonRow(row) {
  return Boolean(row?.drop) && isOpenFeedDrop(row.drop) && viewsLeft(row.drop) <= FOLLOWED_CLOSING_SOON_MAX_LEFT;
}

export function selectFollowedClosingSoon(rows) {
  return (rows || []).filter(isFollowedClosingSoonRow);
}

function dropPostedAt(drop) {
  const t = drop?.createdAt;
  if (!t) return 0;
  if (typeof t.seconds === "number") return t.seconds;
  if (typeof t.toMillis === "function") return t.toMillis() / 1000;
  if (t instanceof Date) return t.getTime() / 1000;
  return 0;
}

/**
 * Games panel list. <=15 stays first. When fewer than three of those qualify,
 * fill the remaining slots (up to four) with other followed creators' open
 * drops, newest post first. Does not change the Home sidebar selection.
 */
export function selectPanelClosingRows(rows) {
  const list = rows || [];
  const primary = selectFollowedClosingSoon(list);
  if (primary.length >= PANEL_CLOSING_MIN_CARDS) return primary;

  const primaryIds = new Set(primary.map((row) => row.drop.id));
  const fallback = list
    .filter((row) => row?.drop && isOpenFeedDrop(row.drop) && !primaryIds.has(row.drop.id))
    .sort((a, b) => dropPostedAt(b.drop) - dropPostedAt(a.drop));

  const slotsLeft = PANEL_CLOSING_MAX_CARDS - primary.length;
  return [...primary, ...fallback.slice(0, Math.max(0, slotsLeft))];
}
